<template>
  <div>
    <div ref="content">
      <!-- <b-container fluid class="mt-4">
        
        <b-row>
          <b-col>
            <b-jumbotron header="Choice Paper">
              <p>
                Choice Paper is the preferred supplier to the Gaming, Hospitality and Retail Industry and is Australia’s largest supplier of Thermal TITO Tickets, providing quality thermal rolls, plain and pre-printed, bond and multi-ply rolls, ribbons, office printers, gaming cards, voucher books, TAB & Keno Rolls and custom printing requirements.
              </p>
              <p>
                Choice Paper aims to be the one stop shop for your paper consumables.
              </p>
              <p>
                <b-btn size="lg" variant="primary" :to="{ name: 'Quick' }">Quick Order</b-btn>
              </p>
            </b-jumbotron>
          </b-col>
        </b-row>

        <b-row class="mb-2">
          <b-col md="2" sm="0"></b-col>
          <b-col md="8" sm="12">
            <b-carousel
              id="carousel1"
              style="text-shadow: 1px 1px 2px #333;max-width: 500px; margin: auto;"
              controls
              indicators
              background="#ababab"
              :interval="4000"
              img-width="1024"
              img-height="480"
            >
              <b-carousel-slide img-src="./static/iStock-1053940780-scaled.webp"></b-carousel-slide>
              <b-carousel-slide img-src="./static/iStock-1008805012-scaled.webp"></b-carousel-slide>
              <b-carousel-slide img-src="./static/iStock-591418312-scaled.webp"></b-carousel-slide>
              <b-carousel-slide img-src="./static/iStock-519913201-scaled.webp"></b-carousel-slide>
              <b-carousel-slide img-src="./static/iStock-186877038-scaled.webp"></b-carousel-slide>
              <b-carousel-slide img-src="./static/Choice_Paper_Tickets-scaled.webp"></b-carousel-slide>
            </b-carousel>
          </b-col>
          <b-col md="2" sm="0"></b-col>
        </b-row>

      </b-container> -->
    </div>
    <CategoryTiles />
  </div>
</template>

<script>
import axios from 'axios';
import ProductService from "../services/ProductService";
import store from "@/store.js";

import ShowPrices from "@/mixins/ShowPrices";
import CategoryTiles from "@/components/Nav/CategoryTiles";

import * as htmlparser from 'htmlparser2';

function GetFeaturedProducts(done) {
  var orderbyColumn = "Name";
  if (store.state.auth.userInfo) {
    orderbyColumn = "ProductService.Name";
  }

  ProductService.GetFeaturedProducts(orderbyColumn)
    .then(response => {
      done(null, response.data);
    })
    .catch(() => {
      done("unable to get products");
    });
}

export default {
  name: "Home",
  data() {
    return {
      featuredProducts: null
    };
  },
  beforeRouteEnter(to, from, next) {
    // GetFeaturedProducts((err, featuredProducts) => {
    //   next(vm => vm.setData(err, featuredProducts));
    // });
    next();
  },
  beforeRouteUpdate(to, from, next) {
    this.featuredProducts = null;
    // GetFeaturedProducts((err, featuredProducts) => {
    //   this.setData(err, featuredProducts);
      next();
    // });
  },
  created(){
    this.loadJumbo();
  },
  methods: {
    async loadJumbo(){
      const res = await axios.get(process.env.MAIN_CONTENT_ENDPOINT, { withCredentials: true });
      var nodeToString = require('dom-serializer').default;
      var handler = new htmlparser.DomHandler((err, dom) => {
        if(err) {
          debugger;
        }
        else {
          dom.filter(i => i.type == 'script').forEach(s => {
            var newScript = document.createElement("script");
            if(s.attribs.src) {
              newScript.src = s.attribs.src;
            }
            else {
              s.children.forEach(c => {
                var textNode = document.createTextNode(c.data);
                newScript.appendChild(textNode);
              });
              Object.assign(newScript, s.attribs);
            }
            this.$refs.content.appendChild(newScript);
          });
          var contentDiv = document.createElement("div");
          contentDiv.innerHTML = nodeToString(dom.filter(i => i.type != 'script'));
          this.$refs.content.appendChild(contentDiv);
        }
      });
      var parser = new htmlparser.Parser(handler);
      parser.write(res.data);
      parser.end();
      // var node = document.createElement("script");
      // var scr = document.createTextNode("alert('Test')");
      // node.appendChild(scr);
      // this.$refs.content.appendChild(node);
    },
    setData(err, featuredProducts) {
      if (err) {
        this.error = err.toString();
      } else {
        this.featuredProducts = featuredProducts;
      }
    },
    navigateToProduct(number) {
      this.$router.push({ name: "ProductDetail", query: { number: number } });
    }
  },
  components: {
    CategoryTiles
  },
  mixins: [ShowPrices]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card:hover {
  background: #f1f2f6;
  cursor: pointer;
}
</style>


<style>
h4 {
  font-size: 1.3rem;
}

</style>


// WEBPACK FOOTER //
// src/components/home.vue